module.exports = __webpack_public_path__ + "static/img/down-corner-8m-x-1m-inverted_256.2543eea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/down-corner-8m-x-1m-inverted_256.png
// module id = 4bPs
// module chunks = 0